<template>
    <div>
        <div class="daily-activity-section">

            <el-row :gutter="20" class="mt-2">
                <el-col :span="24" class="text-right">
                    <i class="el-icon-circle-close cursor-pointer" style="color: black; font-size: 24px;"
                        @click="$emit('closeActivityView')"></i>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <h2 style="color: black; font-weight: 700; font-size: 20px;" class="mt-4">Fixed Tasks / Non Coverage
                        Activities - Hourly View</h2>
                </el-col>
            </el-row>

            <div class="float-right px-5 pb-3 pt-2 flex items-center">
                <el-dropdown trigger="click" class="text-xs" style="margin-right: 25px;" @command="downloadReport">
                    <BaseButton size="medium"
                        type="submit" style="width: 106px;" buttonclass="btn p-2 text-xs py-2">
                        Download <i :class="day_report_loading ? 'el-icon-loading' : 'el-icon-arrow-down'" class="el-icon--right"></i>
                    </BaseButton>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="csv">CSV</el-dropdown-item>
                        <el-dropdown-item command="xlsx">EXCEL</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-button class="btn" style="margin-right: 25px;" @click="downloadReport()">
                    Download Report
                </el-button> -->
                <el-select v-model="selected_day" style="width: 300px" placeholder="Select Day" @change="changeDay">
                    <el-option v-for="item in dayList" :key="item.value" :label="item.title" :value="item.value">
                    </el-option>
                </el-select>
                <el-input v-model="search_activity" class="ml-6" style="width: 300px"
                    placeholder="Search by activity name">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input> 
            </div>
            <div class="daily-activity-fix-tbl">
                <table v-loading="load_table" class="daily-activity-table w-full">
                    <thead>
                        <tr class="tbl-bg-act text-white sticky" style="top:0;">
                            <th class="px-2 py-3 text-left pl-5" style="width: 165px;">
                                ACTIVITY
                                <!-- <el-popover placement="right" trigger="click">
                                <div style="height: 250px; width: 100%; overflow-y:scroll">
                                    <el-checkbox-group v-model="selected_function_list">
                                        <el-checkbox v-for="(fun, fun_index) in filteredFunctionList" :key="fun_index"
                                            class="mb-2 checkbox-lable" :label="getFunctionName(fun)" style="display: block"
                                            @change="hideFunction(fun)"></el-checkbox>
                                    </el-checkbox-group>

                                    <div class="flex justify-between mt-4">
                                        <span class="text-xs cursor-pointer primary-theme-color"
                                            @click="selectAllFunction()">Select all</span>
                                        <span class="text-xs cursor-pointer"
                                            @click="resetSelectedFunction()">Reset</span>
                                    </div>
                                </div>

                                <span slot="reference">
                                    <svg class="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="10" height="10" style="fill: #5f5f5f; margin-left: 5px"
                                    viewBox="0 0 16.018 16">
                                    <path id="Icon_awesome-filter" data-name="Icon awesome-filter"
                                        d="M15.266,0H.752A.75.75,0,0,0,.221,1.28l5.786,5.78V13.5a.75.75,0,0,0,.32.614l2.5,1.749a.751.751,0,0,0,1.181-.614V7.061L15.8,1.28A.75.75,0,0,0,15.266,0Z" />
                                    </svg>
                                </span>
                            </el-popover> -->
                            </th>
                            <th v-for="(time, time_index) in storeTime" :key="'store-time-' + time_index"
                                class="px-2 py-3" >
                                {{ time.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(func, func_index) in dailyActivityList" :key="'function-item-' + func_index"
                            class="tbl-grid-design"
                            :style="[func[0] == 'total' ? { bottom: 0, backgroundColor: 'rgb(205 205 205)' } : '']"
                            :class="[func[0] == 'total' ? 'sticky' : '']">
                            <td class="px-1 py-1 text-left pl-5 font-bold tr-grey" style="width: 165px;">{{ getFunctionName(func[0]) }}</td>
                            <td v-for="(data, data_index) in storeTime" :key="'function-item-' + data_index"
                                class="px-1 py-1 text-center tr-grey"
                                :style="[func[0] == 'total' || data.label == 'TOTAL' ? {backgroundColor: 'rgb(205 205 205)' } : '']"
                                :class="[(func[0] == 'total' || data.label == 'TOTAL') ? 'font-bold' : '']">
                                <div class="tbl-cell-bg shadow-md" :class="[func[0] == 'total' ? 'font-bold' : '']"> {{
                                        func[1][data.time]
                                }} </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import LabourPlanningService from "../../../../../services/labourPalnningService";
import { serverAddrForCSV, serverAddrForXLS } from "../../../../../networkConfig"
import { EventBus } from "../../../../../eventBus";
import { mapState, mapActions } from "vuex";
import exportFromJSON from 'export-from-json'
import myexcel from 'myexcel'
export default {
    name: 'ActivityDailyView',
    props: {
        storeId: {
            default: null,
            type: String
        },
        dayList: {
            default: null,
            type: Array
        },
    },
    data() {
        return {
            day_wise_activity: [],
            selected_day: 'monday',
            day_report_loading: false,
            storeTime: [
                { label: '06 AM', time: '06-00' },
                { label: '07 AM', time: '07-00' },
                { label: '08 AM', time: '08-00' },
                { label: '09 AM', time: '09-00' },
                { label: '10 AM', time: '10-00' },
                { label: '11 AM', time: '11-00' },
                { label: '12 AM', time: '12-00' },
                { label: '01 PM', time: '13-00' },
                { label: '02 PM', time: '14-00' },
                { label: '03 PM', time: '15-00' },
                { label: '04 PM', time: '16-00' },
                { label: '05 PM', time: '17-00' },
                { label: '06 PM', time: '18-00' },
                { label: '07 PM', time: '19-00' },
                { label: '08 PM', time: '20-00' },
                { label: '09 PM', time: '21-00' },
                { label: '10 PM', time: '22-00' },
                { label: '11 PM', time: '23-00' },
                { label: '12 AM', time: '00-00' },
                { label: '01 AM', time: '01-00' },
                { label: '02 AM', time: '02-00' },
                { label: '03 AM', time: '03-00' },
                { label: '04 AM', time: '04-00' },
                { label: '05 AM', time: '05-00' },
                { label: 'TOTAL', time: 'total' },
            ],
            functionList: [],
            selected_function_list: [],
            load_table: false,
            search_activity: ''
        }
    },
    computed: {
        ...mapState("LabourPlanning", ["storeName"]),
        dailyActivityList() {
            let data = JSON.parse(JSON.stringify(this.day_wise_activity));
            let function_list = JSON.parse(JSON.stringify(this.functionList));
            // Get function wise total
            let sum = data[1];
            // let funcSum = data[2];
            let result = [];
            if (data.length) {
                Object.entries(data[0].time_slot_and_function).forEach(obj => {
                    this.filteredFunctionList.forEach(elm => {
                        if (obj[0] == elm) {
                            obj[1].total = this.findAndSetTotal(obj); // Pass function wise total
                            result.push(obj)
                        }
                    });
                });

                // 
                result.push({ 0: 'total', 1: sum ? sum.timewise_sum : {} });

                // Pass All Total 
                result.map(rs => {
                    if (rs[0] == 'total') {
                        rs[1].total = this.day_wise_activity[0].total_functionwise_daywise;
                    }
                    if (rs.length) {
                        rs.push({ name: this.getFunctionName(rs[0]) });
                    }
                });
            }

            //  Filter by Activity
            // if(this.selected_function_list){
            //     return result.filter((item) => {
            //         if (item.length) {
            //             return this.selected_function_list.every(v => item[2].name == v);
            //         }
            //     })
            // }

            // Search by activity name
            if (this.search_activity) {
                return result.filter((item) => {
                    if (item.length) {
                        return this.search_activity.toLowerCase().split(' ').every(v => item[2].name.toLowerCase().includes(v));
                    }
                })
            } else {
                return result;
            }
        },
        filteredFunctionList() {
            let data = [];
            let activity_list = [...this.day_wise_activity];
            if (activity_list.length) {
                Object.entries(activity_list[0].time_slot_and_function).forEach(obj => { data.push(obj[0]) });
            }
            return data;
        }
    },
    created() {
        this.getAllDailyActivity();
    },
    mounted() {
        // this.getFunctionLists();
        
        // this.getTimeWiseActivitySum();
    },
    methods: {
        ...mapActions("CommonStore", ["addDownloadingReportCountAction", "removeDownloadingReportCountAction"]),
        findAndSetTotal(obj) {
            let data = JSON.parse(JSON.stringify(this.day_wise_activity));
            let value = '';
            // console.log(data[1].functionwise_sum);
            Object.entries(data[1].functionwise_sum).forEach(d => {
                if (d[0] == obj[0]) {
                    // console.log(d[0], d[1], obj[0]);
                    value = d[1];
                }
            });
            return value;
        },
        async getAllDailyActivity() {
            await this.getFunctionLists();
            this.load_table = true;
            let payload = [
                {
                    store_id: this.storeName,
                    function_id: null,
                    day: this.selected_day,
                    timewise_sum: false
                },
                {
                    store_id: this.storeName,
                    function_id: null,
                    day: this.selected_day,
                    timewise_sum: true
                },
            ]
            LabourPlanningService.getDailyActivitiesByDay(payload).then((res) => {
                this.day_wise_activity = JSON.parse(res.data);
                this.load_table = false;
            }).catch((err) => {
                console.error(err);
                this.load_table = false;
            })
        },
        getFunctionName(func_id) {
            const function_list = [...this.functionList];
            let func = [];
            if (func_id != 'total' && function_list.length) {
                func = function_list.filter((fs) => fs.id == parseInt(func_id));
            }
            return func.length ? func[0].function : 'Total';
        },
        getFunctionLists() {
            let payload = { outlet_id: this.storeName }
            return LabourPlanningService.getWorkArea(payload).then(response => {
                this.functionList = JSON.parse(response.data);
            }).catch((err) => {
                console.error(err)
            })
        },
        changeDay() {
            this.getAllDailyActivity();
        },
        downloadReport(type) {
            
            this.addDownloadingReportCountAction();
            let payload = {
                store_id: this.storeName,
                day: this.selected_day
            }
            this.day_report_loading = true;
            serverAddrForCSV.post(`/daily_activities_csv/download/`, payload)
                .then(response => {
                    if (response.status == 200) {
                        this.day_report_loading = false;
                        var fileURL = null;
                        if(type == 'xlsx') {
                           let res_data = this.csvJSON(response.data);
                           const data = [ ];
                           res_data.map((elm)=>{
                            data.push(elm);
                           });

                            const excelData = data;
                            const excel = myexcel.new('Calibri light 10 #333333');
                            const headers = Object.keys(excelData[0]);
                            const formatHeader = excel.addStyle({ border: 'none,none,none,thin #333333',
                            font: 'Calibri 12 #111 B' });

                            for (let i = 0; i < headers.length; i++) {
                            excel.set(0, i, 0, headers[i], formatHeader);
                            excel.set(0, i, undefined, 'auto');
                            }

                            for (let i = 0; i < excelData.length; i++) {
                            const data = Object.values(excelData[i]);
                            for (let j = 0; j < headers.length; j++) {
                                excel.set(0, j, i + 1, data[j].toString());
                            }
                            }

                            excel.generate(`${'DailyActivity-' + this.selected_day}`, () => {
                            });
                            
                        } else {
                            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            var fileLink = document.createElement("a");
                            fileLink.href = fileURL;
                            fileLink.setAttribute("download", `${'DailyActivity-' + this.selected_day + '.csv'}`);
                            document.body.appendChild(fileLink);

                            fileLink.click();
                        }
                    }
                    this.removeDownloadingReportCountAction();
                   this.day_report_loading = false;   //hide loader on button
                })
                .catch(err => {
                    console.log(err);
                    this.removeDownloadingReportCountAction();
                    this.day_report_loading = false;   //hide loader on button
                });
        },
        csvJSON(csv) {
            const lines = csv.split('\n')
            const result = []
            const headers = lines[0].split(',')

            for (let i = 1; i < lines.length; i++) {
                if (!lines[i])
                    continue
                const obj = {}
                const currentline = lines[i].split(',')

                for (let j = 0; j < headers.length; j++) {
                    obj[headers[j]] = currentline[j]
                }
                result.push(obj)
            }
            return result
        }

    }

}
</script>

<style lang="scss">
// .Activities .el-dialog__body {
//     padding: 0px 20px !important;
//     padding-bottom: 15px !important;
// }

// .Activities .el-dialog__header {
//     font-weight: 600;
//     padding: 0px 20px !important;
//     padding-top: 5px !important;
// }
</style>
<style lang="scss" scope>
.daily-activity-section{ 
        .btn{ 
            border: 1px solid #e29d5a;
            background-color: #e29d5a;
            text-align: center;
            border-radius: 2px;
            cursor: pointer;
            letter-spacing: .02em;
            -webkit-transition: all .2s ease;
            transition: all .2s ease;
            color: #fff;
        }
        .btn:hover{
            background: #fff;
            color: #e29d5a;
        }
    }
.daily-activity-table {
    th {
        font-size: 13px;
    }

    td {
        font-size: 13px;
    }

    @media only screen and (max-width: 1450px) {
        th {
            font-size: 10px;
        }

        td {
            font-size: 12px;
        }
    } 
}

.tbl-bg-act {
    background-color: #f2f2f2;
    color: #707070;
}

.Activities {
    .daily-activity-section .el-input .el-input__inner {
        text-transform: capitalize;
        padding-left: 30px !important;
    }
}

.daily-activity-section {
    .tbl-grid-design {
        background: #f7f7f7;
    }
    .tbl-grid-design:first-child {
        border-top: 6px solid rgb(255, 255, 255);
        // border-bottom: 6px solid rgb(255, 255, 255);
    }

    .tbl-cell-bg {
        background-color: #fff;
        padding: 8px 0;
    }
}

.StoreSettings .daily-activity-modal .el-dialog {
    width: 100%;
}
</style>